<template>
    <a-row :gutter="24" class="new-row">
        <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
            <a-card :bordered="false" class="new-tree-card">
                <!-- 按钮操作区域 -->
                <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
                    <a-alert type="info" :showIcon="true">
                        <div slot="message">
                            {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                            <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
                        </div>
                    </a-alert>
                    <div style="display: flex;margin-top: 10px;">
                        <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')" />
                        <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
                    </div>
                    <!-- 树-->
                    <a-col :md="24" :sm="24" class="new-tree-col">
                        <template>
                            <a-spin tip="Loading..." :spinning="areaLoading">
                                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                                <el-tree class="filter-tree" :data="areaTree" :props="defaultProps" :expand-on-click-node="false" :filter-node-method="filterNode" :check-on-click-node="true" :check-strictly="checkStrictly" :highlight-current="true" node-key="id" :current-node-key="currentNodeKey" :default-expanded-keys="iExpandedKeys" @node-click="nodeClick" ref="areaTree">
                                </el-tree>
                            </a-spin>
                        </template>
                    </a-col>
                </div>
            </a-card>
        </a-col>
        <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
            <a-icon :type="collapsed ? 'caret-right':'caret-left'" @click="collapsed = !collapsed" class="area-collapsed"></a-icon>
            <a-card :bordered="false" class="new-table-card">
                <!-- 查询区域 -->
                <div class="table-page-search-wrapper">
                    <a-form layout="inline" @keyup.enter.native="searchQuery">
                        <a-row :gutter="24">
                            <a-col :xl="7" :lg="7" :md="8" :sm="24">
                                <a-form-item :label="$t('缴费途径')">
                                    <a-select v-model="queryParam.payWay" :placeholder="$t('请选择缴费途径')">
                                        <a-select-option v-for="(item,value) in payWayObj" :value="value" :key="value">
                                            {{ $t(item) }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :xl="7" :lg="7" :md="8" :sm="24">
                                <a-form-item :label="$t('操作员')">
                                    <a-select v-model="genre" style="width: 100%" :placeholder="$t('请选择操作类型')" @change="handleChange">
                                        <a-select-option v-for="(item,value) in payTypeObj" :value="item.username" :key="item.realname">
                                            {{item.realname}}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :xl="10" :lg="7" :md="8" :sm="24">
                                <a-form-item :label="$t('查询起止时间')">
                                    <a-range-picker v-model="dateRange" show-time :default-value="[moment(new Date()).format('YYYY-MM-DD 00:00:00'), moment(new Date()).format('YYYY-MM-DD 23:59:59')]" format="YYYY-MM-DD HH:mm:ss" :placeholder="[$t('查询起始时间'), $t('查询结束时间')]" @change="onDateRangeChange" @ok="onOk" />
                                </a-form-item>
                            </a-col>
                            <a-col :xl="7" :lg="7" :md="8" :sm="24">
                                <a-form-item :label="$t('价格名称')">
                                    <a-select v-model="queryParam.priceId" :placeholder="$t('请选择价格名称')">
                                        <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.id">
                                            {{data.wtName}}
                                        </a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :xl="4" :lg="7" :md="8" :sm="24">
                                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                                    <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a> -->
                                </span>
                            </a-col>
                        </a-row>
                    </a-form>
                </div>
                <!-- 操作按钮区域 -->
                <div class="table-operator">
                    <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
                    <a-button type="primary" icon="download" @click="handleExportXls($t('售水统计报表'))">{{ $t('导出') }}</a-button>
                </div>
                <div class="flex flex-center" style="margin-bottom: 15px;flex-wrap: wrap;justify-content: flex-start;position: relative;">
                    <div class="flex-item" style="height: 80px;width: 18%;margin-bottom: 5px;flex: auto;" v-for="item in totalList" :key="item.key">
                        <div class="flex-center" style="height: 100%;background: #e6f7ff;border: 1px solid #91d5ff;flex-direction: column;">
                            <div class="flex-center">
                                <span class="" style="margin-left:10px;font-size:24px;font-weight: 500">{{item.key ==1||item.key ==7?item.num:towNumber(item.num)}}</span>
                                <span class="unit" style="color: #999999">{{ $t(item.unit) }}</span>
                            </div>
                            <div class="flex-center" style="color: #999999">{{ $t(item.title) }}</div>
                        </div>
                    </div>
                    <div class="example" v-if="loading">
                        <a-spin :spinning="loading" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"></a-spin>
                    </div>
                </div>
                <!-- table区域-begin -->
                <div class="table-fixed">
                    <a-table ref="table" size="middle" :scroll="{x:true}" bordered rowKey="reportMonthDay" :columns="columns" :dataSource="dataSource" :pagination="false" :loading="loading" class="j-table-force-nowrap" :components="drag(columns)" @change="handleTableChange">
                        <div slot="filterDropdown">
                            <a-card>
                                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                                    <a-row>
                                        <template v-for="item in defColumns">
                                            <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                                                <a-col :span="6" :key="item.key">
                                                    <a-checkbox :value="item.dataIndex" :key="item.title">{{ item.title }}</a-checkbox>
                                                </a-col>
                                            </template>
                                        </template>
                                    </a-row>
                                </a-checkbox-group>
                            </a-card>
                        </div>
                        <span slot="action" slot-scope="text, record">
                            <a @click="handleEdit(record)">{{ $t('详情') }}</a>
                        </span>
                    </a-table>
                </div>
                <meter-daily-statement-modal ref="modalForm" @ok="modalFormOk"></meter-daily-statement-modal>
            </a-card>
        </a-col>
    </a-row>
</template>
<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import MeterDailyStatementModal from './modules/MeterDailyStatementModal'
import { listSize } from '@/utils/util'
import { getAction, putAction } from '@/api/manage'
import moment from 'moment'
import { payTypeObj, payWayObj } from '@/utils/constants/commonConstant'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { axios } from '@/utils/request'
import { isUndefined, isNull, isUndefinedAndNull } from '@/utils/validate'
import TableDragResize from '@/mixins/TableDragResize'
export default {
    name: 'MeterDailyStatementList',
    mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
    components: {
        MeterDailyStatementModal
    },
    data() {
        return {
            description: '日销售报表',
            collapsed: false,
            columns: [],
            currSelected: {},
            payTypeObj,
            payWayObj,
            userPriceCode: [],  //用水性质
            userArray: [],  //操作员
            genre: [],  //操作类型
            date: [],
            //列设置
            settingColumns: [],
            url: {
                list: "/jeecg-charge/meter/payRecordInvoice/getTodayPriceMessage",
                delete: "/jeecg-charge/meter/meterUserWaterReportDay/delete",
                deleteBatch: "/jeecg-charge/meter/meterUserWaterReportDay/deleteBatch",
                exportXlsUrl: "jeecg-charge/meter/payRecordInvoice/getTodayPriceMessageExportXls",
                importExcelUrl: "/jeecg-charge/meter/meterUserWaterReportDay/importExcel",
                userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",  // 用水性质
                dayReportSum: "/jeecg-charge/meter/meterUserPayRecord/dayReportSum", //汇总报表
                user: "/sys/user/departUserList",  //操列表
                deptList: "/sys/sysDepart/getDepartName",
                personUser: "/sys/user/list",  //操作员列表
            },
            dictOptions: {},
            dateType: 2,
            totalList: [
                { key: 1, title: this.$t('收费总金额'), num: '', unit: '元' },
                { key: 2, title: this.$t('营业厅现金'), num: '', unit: '元' },
                { key: 3, title: this.$t('微信支付'), num: '', unit: '元' },
                { key: 8, title: this.$t('微信实收金额'), num: '', unit: '元' },
                { key: 6, title: this.$t('微信手续费'), num: '', unit: '元' },
                { key: 4, title: this.$t('扫码支付'), num: '', unit: '元' },
                { key: 5, title: this.$t('对公转账'), num: '', unit: '元' },
                { key: 9, title: this.$t('净水费总金额'), num: '', unit: '元' },
                { key: 10, title: this.$t('水资源税总金额'), num: '', unit: '元' },
                { key: 11, title: this.$t('排污费总金额'), num: '', unit: '元' },
                { key: 7, title: this.$t('售水吨数'), num: '', unit: 'm³' },
            ],
            queryParam: {
                beginDate: moment(new Date()).format('YYYY-MM-DD 00:00:00'),
                endDate: moment(new Date()).format('YYYY-MM-DD 23:59:59'),
            },
            ids: [],
            dateRange: [moment(new Date()).format('YYYY-MM-DD 00:00:00'), moment(new Date()).format('YYYY-MM-DD 23:59:59')]
        }
    },
    created() {
        this.$store.commit('SET_LAYOUT_TREE', true)
        this.initColumns();
        this.loadData(1);
        this.queryUserPriceCode();
        this.queryUserList();
    },
    computed: {
        importExcelUrl: function () {
            return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        },
        // i18n：列定义使用 computed 以响应语言切换
        defColumns() {
            return [
                {
                    title: '#',
                    dataIndex: '',
                    key: 'rowIndex',
                    width: 60,
                    align: "center",
                    customRender: (t, r, index) => {
                        return parseInt(index) + 1;
                    },
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon'
                    }
                },
                {
                    title: this.$t('价格信息'),
                    align: "center",
                    dataIndex: 'wtName',
                    width: 150,
                    ellipsis: true,
                },
                // {
                //   title:'缴费途径',
                //   align:"center",
                //   dataIndex: 'payWay',
                //   width:100,
                //   ellipsis: true,
                //   customRender:function (t,r,index) {
                //     let obj = payWayObj
                //     if(!isUndefined(obj[t])) {
                //       return obj[t]
                //     }
                //     return '未知'
                //   }
                // },
                {
                    title: this.$t('总价(元)'),
                    align: "center",
                    dataIndex: 'totalPrice',
                    width: 100,
                    ellipsis: true,
                },
                {
                    title: this.$t('售水吨数(m³)'),
                    align: "center",
                    dataIndex: 'sellWater',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 100,
                    ellipsis: true,
                },
                {
                    title: this.$t('净水费(元)'),
                    align: "center",
                    dataIndex: 'basicWaterPrice',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 100,
                    ellipsis: true,
                },
                {
                    title: this.$t('水资源税(元)'),
                    align: "center",
                    dataIndex: 'waterResourceFee',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 100,
                    ellipsis: true,
                },
                {
                    title: this.$t('排污费(元)'),
                    align: "center",
                    dataIndex: 'sewageFee',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 100,
                    ellipsis: true,
                },
                {
                    title: this.$t('收费金额(元)'),
                    align: "center",
                    dataIndex: 'totalMoney',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 100,
                    ellipsis: true,
                },
                {
                    title: this.$t('营业厅现金(元)'),
                    align: "center",
                    dataIndex: 'businessSumPay',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 150,
                    ellipsis: true,
                },
                {
                    title: this.$t('微信支付(元)'),
                    align: "center",
                    dataIndex: 'weChatSumPay',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 100,
                    ellipsis: true,
                },
                {
                    title: this.$t('微信手续费(元)'),
                    align: "center",
                    dataIndex: 'weChatSumPayPremium',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 150,
                    ellipsis: true,
                },
                {
                    title: this.$t('微信实到账(元)'),
                    align: "center",
                    dataIndex: 'weChatRealCharge',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 150,
                    ellipsis: true,
                },
                {
                    title: this.$t('扫码支付(元)'),
                    align: "center",
                    dataIndex: 'scanTheCodeCharge',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 100,
                    ellipsis: true,
                },
                {
                    title: this.$t('对公转账(元)'),
                    align: "center",
                    dataIndex: 'totalPublicAccount',
                    customRender: (text) => {
                        return text == null ? '0.00' : text
                    },
                    width: 100,
                    ellipsis: true,
                },
                // {
                //   title: '操作',
                //   dataIndex: 'action',
                //   align:"center",
                //   fixed:"right",
                //   width:100,
                //   scopedSlots: { customRender: 'action' }
                // }
            ]
        },
    },
    methods: {
        moment,
        queryUserList() {   //操作员请求
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            getAction(this.url.personUser, params).then((res) => {
                if (res.success) {
                    this.payTypeObj = res.result.records;
                }
            })
        },
        ...mapGetters(["nickname", "avatar", "userInfo"]),
        loadListData(arg) {
            if (!this.url.list) {
                this.$message.error(this.$t('请设置url.list属性!'))
                return
            }
            //加载数据 若传入参数1则加载第一页的内容
            if (arg === 1) {
                this.ipagination.current = 1;
            }
            var params = this.getQueryParams();//查询条件
            this.loading = true;
            putAction(this.url.list, params).then((res) => {
                if (res.success) {
                    this.dataSource = res.result.meterUserPayRecordTodayMessageVOList;
                    this.ipagination.total = res.result.total;
                    this.totalList[0].num = res.result.totalCharge || 0;
                    this.totalList[1].num = res.result.totalBusinessCharge || 0;
                    this.totalList[2].num = res.result.totalWeChatCharge || 0;
                    this.totalList[3].num = res.result.wechatTotalRealCharge || 0;
                    this.totalList[4].num = res.result.wechatPayPremiumCharge || 0;
                    this.totalList[5].num = res.result.scanTheCodeCharge || 0;
                    this.totalList[6].num = res.result.unionPayCharge || 0;
                    this.totalList[7].num = res.result.basicWaterPriceTotal || 0;
                    this.totalList[8].num = res.result.waterResourceFeeTotal || 0;
                    this.totalList[9].num = res.result.sewageFeeTotal || 0;
                    this.totalList[10].num = res.result.sellWater || 0;
                }
                if (res.code === 510) {
                    this.$message.warning(res.message)
                }
                this.loading = false;
            })
        },
        handleChange(value) {
            console.log("value: " + value)
            this.queryParam.createBy = value + "";
        },
        queryUserPriceCode() {  //用水性质请求
            let params = {}
            params.pageNo = 1;
            params.pageSize = listSize;
            getAction(this.url.userPriceCode, params).then((res) => {
                if (res.success) {
                    this.userPriceCode = res.result.records;
                    console.log(this.userPriceCode);
                }
            })
        },
        // queryUserList() { //操作员请求
        //   getAction(this.url.deptList, {pageNo: 1,pageSize: 1,orgCode: this.userInfo().orgCode}).then((res) => {
        //     if(res.success&&res.result.id){
        //       let params = {}
        //       params.pageNo = 1;
        //       params.pageSize = listSize;
        //       console.log(this.userInfo())
        //       params.depId = res.result.id;
        //       getAction(this.url.user, params).then((res) => {
        //         if(res.success){
        //           this.userArray = res.result.records;
        //           console.log(this.userArray);
        //         }
        //       }) 
        //     }
        //   })
        // },
        querydayReportSum() {   //汇总报表
            var params = this.getQueryParams();//查询条件
            this.loading = true;
            getAction(this.url.dayReportSum, params).then((res) => {
                if (res.success) {
                    this.totalList[0].num = res.result.dayRecordCount
                    this.totalList[1].num = res.result.daySumPay
                    this.totalList[2].num = res.result.daySumBack
                    this.totalList[3].num = res.result.daySumPay - res.result.daySumBack;
                }
            })
        },
        towNumber(val) {   //保留两位小数  
            if (!val) {
                return 0;
            }
            return val.toFixed(2);
        },
        handleEdit(record) {
            this.$refs.modalForm.edit(this.queryParam, record);
            this.$refs.modalForm.title = this.$t("详情");
        },
        //列设置更改事件
        onColSettingsChange(checkedValues) {
            var key = this.$route.name + ":colsettings";
            Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
            this.settingColumns = checkedValues;
            const cols = this.defColumns.filter(item => {
                if (item.key == 'rowIndex' || item.dataIndex == 'action') {
                    return true
                }
                if (this.settingColumns.includes(item.dataIndex)) {
                    return true
                }
                return false
            })
            this.columns = cols;
        },
        initColumns() {
            //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
            //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
            var key = this.$route.name + ":colsettings";
            let colSettings = Vue.ls.get(key);
            if (colSettings === null || colSettings == undefined) {
                let allSettingColumns = [];
                this.defColumns.forEach(function (item, i, array) {
                    allSettingColumns.push(item.dataIndex);
                })
                this.settingColumns = allSettingColumns;
                this.columns = this.defColumns;
            } else {
                this.settingColumns = colSettings;
                const cols = this.defColumns.filter(item => {
                    if (item.key == 'rowIndex' || item.dataIndex == 'action') {
                        return true;
                    }
                    if (colSettings.includes(item.dataIndex)) {
                        return true;
                    }
                    return false;
                })
                this.columns = cols;
            }
        },
        onOk(value) {
            console.log('onOk:', value);
        },
        loadData(arg) {
            // this.querydayReportSum();
            this.loadListData(arg);
        },
        handleTableChange(pagination, filters, sorter) {
            //分页、排序、筛选变化时触发
            //TODO 筛选
            if (Object.keys(sorter).length > 0) {
                this.isorter.column = sorter.field;
                this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
            }
            this.ipagination = pagination;
            this.loadListData();
        },
        searchReset() {
            this.dateRange = [moment(new Date()).format('YYYY-MM-DD 00:00:00'), moment(new Date()).format('YYYY-MM-DD 23:59:59')];
            this.queryParam = {
                beginDate: moment(new Date()).format('YYYY-MM-DD 00:00:00'),
                endDate: moment(new Date()).format('YYYY-MM-DD 23:59:59'),
            }
            this.resetAareaData()
            this.date = []
            this.genre = []
            this.loadData(1);
        },
        //导出
        handleExportXls(fileName) {
            if (!fileName || typeof fileName != "string") {
                fileName = this.$t("导出文件")
            }
            axios({
                url: this.url.exportXlsUrl,
                data: this.queryParam,
                method: 'put',
                responseType: 'blob',
                timeout: 10 * 60 * 1000 // 重置导出文件的超时时间10分钟
            }).then(res => {
                if (!res) {
                    this.$message.warning(this.$t("文件下载失败"))
                    return
                }
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    window.navigator.msSaveBlob(new Blob([res], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
                } else {
                    let url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel' }))
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    link.setAttribute('download', fileName + '.xls')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link); //下载完成移除元素
                    window.URL.revokeObjectURL(url); //释放掉blob对象
                }
            })
        },
        nodeClick(record, node, data) {
            // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
            if (node.checked) {
                // 递归获取全部区域id
                this.ids = [];
                this.currentNodeKey = this.areaIdRecursion(record);
                this.$refs.areaTree.setCheckedKeys([record.id]);
                this.currSelected = Object.assign({}, record);
                this.queryParam.sysOrgCodeList = this.currentNodeKey;//售水统计报表使用
            } else {
                this.currentNodeKey = null
                this.currSelected = {};
                // 有的接口是areaId有的接口是userAreaId，兼容两个都写
                delete this.queryParam.userAreaId;
                delete this.queryParam.areaId;
            }
            this.loadData(1);
        },
        areaIdRecursion(obj) {
            this.ids.push(obj.id);
            obj.children && obj.children.map(item => {
                this.ids.push(item.id);
                if (item.children) {
                    this.areaIdRecursion(item);
                }
            });
            return this.ids;
        }
    }
}
</script>
<style scoped>
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
}
.example {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    background-color: rgba(230, 247, 255, 0.7);
    width: 100%;
    height: 100%;
}
</style>